import type { ModalConfig } from "./types";

export const recurringChargeModalsModalUrlConfig = {
  // Recurring Charge Modals
  //
  // `entityName` is the hyphenated string `/recurring-charges` passes to
  // `UniversalEntityPage`, not the underscored entity-registry key — the
  // row-click handler builds its modal id from the former.
  "recurring-charges-detail": {
    modalId: "recurring-charges-detail",
    entityName: "recurring-charges",
    singularParam: "recurringChargeId",
    pluralParam: "recurringChargesId",
    displayName: "Recurring Charge",
  },
} as const satisfies Record<string, ModalConfig>;
